<template>
  <div
    class="video-preview bg-black rounded-12 relative elevated-shadow overflow-hidden flex justify-center items-center cursor-pointer"
    @click="$emit('play')"
  >
    <img
      :src="preview"
      alt=""
      class="w-full h-full object-cover opacity-50 pointer-events-none"
    />
    <ion-img
      src="/assets/button-icons/play-white.svg"
      class="m-auto absolute z-10 pointer-events-none"
    />
  </div>
</template>

<script>
import { IonImg } from "@ionic/vue";

export default {
  emits: ["play"],

  components: {
    IonImg,
  },

  props: {
    preview: {
      type: String,
    },
  },
};
</script>

<style scoped>
.video-preview {
  height: 221px;
}
</style>
